import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  isMobileOrTablet: false,
};

const layoutSlice = createSlice({
  name: "layoutSlice",
  initialState,
  reducers: {
    deviceIsMobileOrTablet: (state, action) => {
      state.isMobileOrTablet = action.payload;
    },
  }
})

export const { deviceIsMobileOrTablet } = layoutSlice.actions;

export default layoutSlice.reducer;
